import { UrlSegment } from '@angular/router';

export function createLanguageMatcher(routes: { [key: string]: string }) {
  return function languageMatcher(
    url: UrlSegment[]
  ): { consumed: UrlSegment[] } | null {
    if (!url.length) return null;

    /**
     * INFO: languageRepository saves lang in localStorage
     */
    const currentLang = localStorage.getItem('language')
      ? JSON.parse(localStorage.getItem('language')!).lang
      : 'pl';

    const firstSegment = url[0].path;

    if (currentLang === 'pl' && Object.values(routes).includes(firstSegment)) {
      return { consumed: [url[0]] };
    }

    if (currentLang === 'en' && Object.keys(routes).includes(firstSegment)) {
      return { consumed: [url[0]] };
    }

    return null;
  };
}
